import { ObjectValues } from '../utils';

export const FEATURE_FLAGS_TYPES = {
  DASHBOARD: 'dashboard',
  INGESTION: 'ingestion',
  MEDIA_MANAGER: 'media-manager',
  MEDIA_MANAGER_GRAPHICS: 'media-manager-graphics',
  LINEAR_TV: 'linear-tv',
  ON_DEMAND: 'on-demand',
  ANALYTICS: 'analytics',
  SCHEDULE: 'schedule',
  EPG: 'epg',
  PLAYOUT: 'playout',
  USER_MANAGEMENT: 'user-management',
  USER_MANAGEMENT_EDIT: 'user-management-edit',
  MEDIA_MANAGER_CREATE_ASSET: 'media-manager-create-assets',
  MEDIA_MANAGER_CREATE_COLLECTION: 'media-manager-create-collection',
  MEDIA_MANAGER_EDIT_DETAILS: 'media-manager-edit-details',
  ON_DEMAND_CREATE_DELIVERY: 'on-demand-create-delivery',
  INGESTION_CREATE: 'ingestion-create',
  INGESTION_EDIT: 'ingestion-edit',
  GLOBAL_SETTINGS: 'global-settings',
  ALERTS: 'alerts',
  HEY_MAGGIE: 'hey-maggie',
} as const;

export type FeatureFlagsType = ObjectValues<typeof FEATURE_FLAGS_TYPES>;

export const DefaultFeatureFlags = {
  [FEATURE_FLAGS_TYPES.DASHBOARD]: true,
  [FEATURE_FLAGS_TYPES.INGESTION]: true,
  [FEATURE_FLAGS_TYPES.MEDIA_MANAGER]: true,
  [FEATURE_FLAGS_TYPES.MEDIA_MANAGER_GRAPHICS]: true,
  [FEATURE_FLAGS_TYPES.MEDIA_MANAGER_CREATE_ASSET]: true,
  [FEATURE_FLAGS_TYPES.MEDIA_MANAGER_CREATE_COLLECTION]: true,
  [FEATURE_FLAGS_TYPES.MEDIA_MANAGER_EDIT_DETAILS]: true,
  [FEATURE_FLAGS_TYPES.ON_DEMAND_CREATE_DELIVERY]: true,
  [FEATURE_FLAGS_TYPES.LINEAR_TV]: true,
  [FEATURE_FLAGS_TYPES.ON_DEMAND]: true,
  [FEATURE_FLAGS_TYPES.ANALYTICS]: true,
  [FEATURE_FLAGS_TYPES.SCHEDULE]: true,
  [FEATURE_FLAGS_TYPES.USER_MANAGEMENT_EDIT]: true,
  [FEATURE_FLAGS_TYPES.EPG]: true,
  [FEATURE_FLAGS_TYPES.PLAYOUT]: true,
  [FEATURE_FLAGS_TYPES.USER_MANAGEMENT]: true,
  [FEATURE_FLAGS_TYPES.INGESTION_CREATE]: true,
  [FEATURE_FLAGS_TYPES.INGESTION_EDIT]: true,
  [FEATURE_FLAGS_TYPES.GLOBAL_SETTINGS]: true,
  [FEATURE_FLAGS_TYPES.ALERTS]: true,
  [FEATURE_FLAGS_TYPES.HEY_MAGGIE]: true,
};
